module.exports = __webpack_public_path__ + "static/img/pic3.5bc407a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case1/pic3.jpg
// module id = vxpJ
// module chunks = 1